import axios from "../network/reuset";
import { normalizeReportParams } from "@/utils/report";

const getReport = {
  async getAccount(params = {}) {
    const response = await axios.get("/api/admin/report/account", {
      params,
    });
    return response && response.data ? response.data : response;
  },
  async saveAccount(payload = {}) {
    const response = await axios.post("/api/admin/report/account/save", payload);
    return response && response.data ? response.data : response;
  },
  async getFullReport(params = {}) {
    const response = await axios.get("/api/admin/report/full", {
      params: normalizeReportParams(params, {
        dateKeys: ["startdate", "enddate"],
      }),
    });
    return response && response.data ? response.data : response;
  },
  async getHourlyReport(params = {}) {
    const response = await axios.get("/api/admin/report/hourly", {
      params: normalizeReportParams(params, {
        dateKeys: ["start_date", "end_date"],
      }),
    });
    return response && response.data ? response.data : response;
  },
};

export default getReport;
